import {Component, Input, OnInit} from '@angular/core';
import {DiscrepanciesData} from '../../../domain/discrepancies-data.model';
import {AdStatsDiscrepanciesService} from '../../../../../shared/services/ad-stats-discrepancies.service';
import {DateRangeType} from '../../../../../shared/domain/date-range-type.enum';
import {MomentDateUtils} from '../../../../../shared/utils/moment-date-utils';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import {WidgetDiscrepanciesSettingsDialogComponent} from './widget-discrepancies-settings-dialog.component';
import {WidgetDiscrepanciesSettings} from './widget-discrepancies-settings.model';
import {DateRangeHolder} from '../../../../../shared/domain/date-range-holder.model';
import {DemandPartnerDbName} from '../../../domain/demand-partner.enum';

@Component({
  selector: 'cm-widget-discrepancies',
  template: `
    <cm-widget>
      <cm-widget-title>
        Discrepancies
        <i class="fas fa-cog hand" aria-hidden="true" (click)="openSettings()"></i>
      </cm-widget-title>
      <cm-widget-actions class="d-flex align-items-center">
        <button mat-icon-button color="primary" (click)="refreshData()">
          <i class="fas fa-sync"></i>
        </button>
        <cm-date-range-dropdown [dateRange]="dateRange"
                                [allowedDateRangeTypes]="allowedDateRangeTypes"
                                (dateRangeChanged)="onDateRangeChanged($event)">
        </cm-date-range-dropdown>
      </cm-widget-actions>
      <cm-widget-content>
        <div class="card-message" [hidden]="!loading">
          <mat-spinner [color]="'primary'" [mode]="'indeterminate'"
                       [diameter]="'30'"></mat-spinner>
        </div>
        <p *ngIf="noData" [hidden]="loading" class="card-message">No data available for chosen settings</p>
        <cm-discrepancies-table [paginator]="paginator"
                                #table
                                [hidden]="loading || noData"
                                [visibleColumns]="['adUnitName', 'demandPartner', 'revenueDiscrepancy', 'revenueDiscrepancyAmount']"
                                [data]="data"></cm-discrepancies-table>
      </cm-widget-content>
      <cm-widget-footer>
        <mat-paginator #paginator
                       [hidden]="loading || noData"
                       [pageSize]="10"
                       [pageSizeOptions]="[5, 10, 20]">
        </mat-paginator>
      </cm-widget-footer>
    </cm-widget>
  `,
})
export class WidgetDiscrepanciesComponent implements OnInit {

  @Input()
  loading = false;

  allowedDateRangeTypes = [
    DateRangeType.YESTERDAY,
    DateRangeType.THIS_WEEK,
    DateRangeType.LAST_7_DAYS,
    DateRangeType.LAST_MONTH,
    DateRangeType.LAST_30_DAYS,
    DateRangeType.THIS_MONTH
  ];

  data: DiscrepanciesData[] = [];

  dateRange = MomentDateUtils.getDatesFromRange(DateRangeType.YESTERDAY);

  public settings: WidgetDiscrepanciesSettings = {
    dateFrom: this.dateRange.dateFrom,
    dateTo: this.dateRange.dateTo,
    dateRangeType: DateRangeType.YESTERDAY,
    adUnitIds: [],
    demandPartnerIds: [],
    predicates: []
  };

  noData: boolean;

  constructor(private service: AdStatsDiscrepanciesService,
              private matDialog: MatDialog) {
  }

  ngOnInit(): void {
    this.refreshData();
  }

  refreshData() {
    this.loading = true;
    this.service.discrepancies(this.settings).subscribe(data => {
        this.loading = false;
        this.data = data.filter(d => d.demandPartner != DemandPartnerDbName.ADX);
        this.noData = !data || !data.length
      },
      () => {
        this.loading = false;
      });
  }

  openSettings() {
    this.matDialog.open(WidgetDiscrepanciesSettingsDialogComponent, <MatDialogConfig>{
      data: {
        settings: this.settings
      },
      width: '80vw'
    }).afterClosed().subscribe(result => {
      if (result) {
        this.settings = result;
        this.dateRange = new DateRangeHolder(this.settings.dateFrom, this.settings.dateTo, this.settings.dateRangeType);
        this.refreshData();
      }
    });
  }

  onDateRangeChanged(event: DateRangeHolder) {
    this.dateRange = event;
    this.settings.dateFrom = event.dateFrom;
    this.settings.dateTo = event.dateTo;
    this.settings.dateRangeType = event.dateRangeType;
    this.refreshData();
  }

}

